import { InspectionAssignmentOverviewDTO } from "../../../common/types/common.dto.types";

// ==============================|| VIEWS - PAGES - INSPECTION ASSIGNMENT OVERVIEW - ACTION ||============================== //

export const GETASSIGNEDINSPECTIONS = "GETASSIGNEDINSPECTIONS";

export const getAssignedInspections = (
  searchParameter: InspectionAssignmentOverviewDTO
) => {
  return {
    type: GETASSIGNEDINSPECTIONS,
    payload: {
      searchParameter: searchParameter,
    },
  };
};
